import request from '@/utils/request'

/**
 * 设计师报价记录
 * @param data
 */
export const getDesignList = (data) => {
  return request({
    url: '/sol/wap/designer/quoted/page',
    method: 'post',
    data: data
  })
}
/**
 * 报价记录详情
 */
export const getDesignDetail = (data) => {
  return request({
    url: '/sol/wap/designer/quoted/detail',
    method: 'get',
    params: data
  })
}
/**
 * 添加报价
 * @param data
 */
export const addDesignquoted = (data) => {
  return request({
    url: '/sol/wap/designer/quoted/add',
    method: 'post',
    data: data
  })
}
/**
 * 更新状态
 * @param params
 */
export const updateDesignquoted = (params) => {
  return request({
    url: '/sol/wap/designer/quoted/update',
    method: 'post',
    params: params
  })
}

/**
 * 设计任务
 * @param data
 */
export const getDesigntask = (data) => {
  return request({
    url: '/sol/wap/order_tasks/new',
    method: 'post',
    data: data
  })
}
/**
 * 设计任务详情
 * @param data
 */
export const getTaskdatai = (taskId) => {
  return request({
    url: `/sol/wap/order_tasks/${taskId}`,
    method: 'get',
  })
}

/**
 * 更新设计任务状态
 * @param data
 */
export const updateDesigntask = (params) => {
  return request({
    url: '/sol/wap/order_tasks/update',
    method: 'PUT',
    params: params
  })
}

/**
 * 设计合伙人是否存在
 * @param data
 */
export const isDesginer = (params) => {
  return request({
    url: '/sol/pc/designer_partner/exist',
    method: 'GET',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/designer/designer.js